import { useEffect, useState } from 'react';

const usePlannerData = (sessionId, modalOpen) => {
  const [goals, setGoals] = useState([]);
  const [messages, setMessages] = useState([]);
  const [newGoal, setNewGoal] = useState('');
  const [newMessage, setNewMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!modalOpen || !sessionId) return;
    setLoading(true);
    fetch(`/api/planner-sessions/${sessionId}/goals`)
      .then(res => res.json())
      .then(data => {
        setGoals(data);
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to fetch goals');
        setLoading(false);
      });
  }, [modalOpen, sessionId]);

  useEffect(() => {
    if (!modalOpen || !sessionId) return;
    console.log('Fetching discussion messages');
    fetch(`/api/planner-sessions/${sessionId}/discussion`)
      .then(res => res.json())
      .then(data => {
        console.log('Discussion messages received:', data.logs);
        setMessages(Array.isArray(data.logs) ? data.logs : []);
      })
      .catch(() => {
        console.error('Failed to fetch messages');
      });
  }, [modalOpen, sessionId]);

  const handleAddGoal = () => {
    if (!newGoal) return;
    setLoading(true);
    fetch(`/api/planner-sessions/${sessionId}/goals`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ goal: newGoal }),
    })
      .then(res => res.json())
      .then(data => {
        setGoals(prev => [...prev, data]);
        setNewGoal('');
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to add goal');
        setLoading(false);
      });
  };

  const refreshMessages = () => {
    console.log('Refreshing discussion messages');
    fetch(`/api/planner-sessions/${sessionId}/discussion`)
      .then(res => res.json())
      .then(data => {
        console.log('Refreshed messages:', data.logs);
        setMessages(Array.isArray(data.logs) ? data.logs : []);
      })
      .catch(() => {
        console.error('Failed to refresh messages');
      });
  };

  return {
    goals,
    setGoals,
    newGoal,
    setNewGoal,
    handleAddGoal,
    loading,
    error,
    messages,
    refreshMessages,
    newMessage,
    setNewMessage
  };
};

export default usePlannerData;